
export enum CurveColor {
    color1 = "#212121",
    color2 = "#323232",
    color3 = "#0d7377",
    color4 = "#14ffeb",
    color5 = "#ffa600"
}